export const personalMenu = [
    {
        "actionId": 777,
        "actionName": "合约管理",
        "actionCode": "shop-management::contract-manager",
        "actionType": 1,
        "isShow": 1,
        "url": "",
        "icon": "iconheyue",
        "parentId": 400,
        "sort": 18,
        "adminFlag": true,
        "systemId": 3,
        "level": 2,
        "title": "合约管理",
        "name": "contract-manager",
        "children": [
            {
                "actionId": 779,
                "actionName": "开通合约",
                "actionCode": "shop-management::contract-manager::open-contract",
                "actionType": 1,
                "isShow": 1,
                "url": "",
                "icon": "",
                "parentId": 777,
                "sort": 1,
                "adminFlag": true,
                "systemId": 3,
                "level": 3,
                "title": "开通合约",
                "name": "open-contract",
                "children": []
            },
            {
                "actionId": 780,
                "actionName": "我的合约",
                "actionCode": "shop-management::contract-manager::my-contract",
                "actionType": 1,
                "isShow": 1,
                "url": "",
                "icon": "",
                "parentId": 777,
                "sort": 2,
                "adminFlag": true,
                "systemId": 3,
                "level": 3,
                "title": "我的合约",
                "name": "my-contract",
                "children": []
            }
        ]
    },
    {
        "actionId": 812,
        "actionName": "账号管理",
        "actionCode": "shop-management::account-manager",
        "actionType": 1,
        "isShow": 1,
        "url": "",
        "icon": "iconzhanghao",
        "parentId": 400,
        "sort": 20,
        "adminFlag": true,
        "systemId": 3,
        "level": 2,
        "title": "账号管理",
        "name": "account-manager",
        "children": [
            {
                "actionId": 814,
                "actionName": "我的账号",
                "actionCode": "shop-management::account-manager::my-account",
                "actionType": 1,
                "isShow": 1,
                "url": "",
                "icon": "",
                "parentId": 812,
                "sort": 1,
                "adminFlag": true,
                "systemId": 3,
                "level": 3,
                "title": "我的账号",
                "name": "my-account",
                "children": []
            }
        ]
    },
    {
        "actionId": 813,
        "actionName": "消息中心",
        "actionCode": "shop-management::personal-message",
        "actionType": 1,
        "isShow": 1,
        "url": "",
        "icon": "iconxiaoxi",
        "parentId": 400,
        "sort": 22,
        "adminFlag": true,
        "systemId": 3,
        "level": 2,
        "title": "消息中心",
        "name": "personal-message",
        "children": [
            {
                "actionId": 815,
                "actionName": "我的消息",
                "actionCode": "shop-management::personal-message::my-message",
                "actionType": 1,
                "isShow": 1,
                "url": "",
                "icon": "",
                "parentId": 813,
                "sort": 0,
                "adminFlag": true,
                "systemId": 3,
                "level": 3,
                "title": "我的消息",
                "name": "my-message",
                "children": []
            }
        ]
    }
]

export const personalRouter = ['my-account', 'open-contract', 'my-contract', 'my-message']